// Formats a Date as YYYY-MM-DD using its local calendar date, not UTC.
// Date.prototype.toISOString() converts to UTC first, which shifts the
// date backward by a day for any timezone ahead of UTC.
export function formatDateAsLocalISO(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function sumDeviceTypes(deviceTypes: { count: number }[]): number {
  return deviceTypes.reduce((s, d) => s + d.count, 0);
}
